/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.witchsky.theme.authFull'

type $nsid = typeof $nsid

export { $nsid }

const main = /*#__PURE__*/ l.permissionSet(
  $nsid,
  [
    /*#__PURE__*/ l.permission('repo', {
      collection: [
        'app.witchsky.theme.colors',
        'app.witchsky.theme.collection',
        'app.witchsky.theme.collectionitem',
        'app.witchsky.theme.saved',
      ],
      action: ['create', 'update', 'delete'],
    }),
  ],
  { title: 'Witchsky themes', detail: 'Use and manage interface themes' },
)

export { main }
